export default __webpack_public_path__ + "static/media/bezier-curve-sketch.98a0c3bd.mp4";